import { createContext } from 'react'

const GeneralContext = createContext({
    notification: { type: '', message: '', title: '' }
})

export default GeneralContext
